import React, {useState, useEffect} from 'react'
import { Form } from "react-bootstrap";

const RestSubtitle = ({ item }) => {
    const [subtitles, setSubtitles] = useState(item.subtitles);
    const [time, setTime] = useState(item.time);
    
    useEffect(() => {
        if (subtitles)
            item.subtitles = subtitles;
    }, [subtitles])

    useEffect(() => {
        if (time)
            item.time = time;
    }, [time])

    return (
        <>
            <tr>
                <td className="th w-1/6">자막 설정</td>
                <td className="w-3/6 border-right-0">
                    <Form.Control type="text" placeholder="자막을 입력하세요." value={subtitles} onChange={e => setSubtitles(e.target.value)} />
                </td>
                <td className="w-2/6 border-right-0">
                    <Form.Control type="number" placeholder="자막 시작 시간" value={time} onChange={e => setTime(e.target.value)} />
                </td>
            </tr>
        </>
    )
}

export default RestSubtitle;